











import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        SimpleMap
    }
})
export default class ModalMachinesView extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    timeoutInterval: number = 15000;
    loadingMap: boolean = false;
    lastReportInterval: any = null;

    @Emit()
    closeModal() {}

    @Emit()
    updateVehicles() {}

    mounted() {}

    setMarkers(vehicles) {
        let self = this;
        let refMap = self.$refs.machineViewMap as HTMLFormElement;
        refMap.setMarkers(vehicles);

        self.lastReportInterval = setInterval(() => {
            self.updateVehicles();
        }, self.timeoutInterval);
    }
    clearLastReportInterval() {
        if (this.lastReportInterval) {
            clearInterval(this.lastReportInterval);
        }
    }
}
